import request from '@/utils/request'

// 查询社区小组帖子关联商品列表
export function listCommunityGroupPostGoods(query) {
  return request({
    url: '/biz/admin/community/community/group/post/goods/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区小组帖子关联商品分页
export function pageCommunityGroupPostGoods(query) {
  return request({
    url: '/biz/admin/community/community/group/post/goods/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区小组帖子关联商品详细
export function getCommunityGroupPostGoods(data) {
  return request({
    url: '/biz/admin/community/community/group/post/goods/detail',
    method: 'get',
    params: data
  })
}

// 新增社区小组帖子关联商品
export function addCommunityGroupPostGoods(data) {
  return request({
    url: '/biz/admin/community/community/group/post/goods/add',
    method: 'post',
    data: data
  })
}

// 修改社区小组帖子关联商品
export function updateCommunityGroupPostGoods(data) {
  return request({
    url: '/biz/admin/community/community/group/post/goods/edit',
    method: 'post',
    data: data
  })
}

// 删除社区小组帖子关联商品
export function delCommunityGroupPostGoods(data) {
  return request({
    url: '/biz/admin/community/community/group/post/goods/delete',
    method: 'post',
    data: data
  })
}
